import { initMiniatures } from "../cities/miniatures.js";
/* eslint-disable no-restricted-syntax */
/* eslint-disable quote-props */
function declineCity(city) {
    if (!city) return "";

    const exceptions = {
        "Москва": "Москве",
        "Санкт-Петербург": "Санкт-Петербурге",
        "Нижний Новгород": "Нижнем Новгороде",
        "Ростов-на-Дону": "Ростове-на-Дону",
        // можно добавить дополнительные исключения
    };

    if (exceptions[city]) return exceptions[city];

    // Основные окончания и их склонения
    const endings = [
        { ending: "а", result: `${city.slice(0, -1)}е` },
        { ending: "я", result: `${city.slice(0, -1)}е` },
        { ending: "ь", result: `${city.slice(0, -1)}и` },
        { ending: "и", result: `${city}` }, // города, которые уже оканчиваются на "и"
    ];

    // Проверка по окончаниям
    for (const { ending, result } of endings) {
        if (city.endsWith(ending)) {
            return result;
        }
    }

    // По умолчанию для городов без особых окончаний
    return `${city}е`;
}

export function setSkinDiagnostictCenterTitles(city, serviceType) {
    const centerEl = document.querySelector(`#center-${serviceType}`);
    const lastBreadcrumbItem = document.querySelector(`#center-${serviceType} .breadcrumbs__item:last-child`);
    const mainTitleEl = document.querySelector(`#center-${serviceType} .skin-diagnostic-center__main-title`);
    const addressTitle = document.querySelector(`#center-${serviceType} .skin-diagnostic-center__address-title`);

    const [cityName, address] = city.split(",");

    const newAddress = `${declineCity(cityName)}${address ? `, ${address}` : ""}`;

    const newMainTitle = `Центр диагностики кожи в ${newAddress}`;

    const newAddressTitle = `Адрес и график работы центра в ${newAddress}`;

    if (["msk", "arbat", "moskva-m-tsvetnoy-bulvar"].includes(serviceType)) {
        const descriptionEl = document.createElement("p");

        const benefits = document.createElement("div");

        descriptionEl.classList.add("p", "description");

        descriptionEl.innerText = "В Центрах диагностики кожи вы можете получить бесплатную консультацию косметолога, подобрать уход и получить миниатюры рекомендованной косметики в подарок";

        mainTitleEl.insertAdjacentElement("afterend", descriptionEl);

        benefits.innerHTML = `
            <div class="benefits">
                <h3 class="h3">На бесплатной консультации косметолога в наших Центрах</h3>
                <div class="card-wrapper card-wrapper--2 card-wrapper--md-5">
                    <div class="card card--benefit card--bordered card-with-miniature">
                        <i class="card__icon icon-percent" aria-label="icon percent"></i>
                        <div class="card__content">
                            <p class="p card__content-text">Скидка 15% на всю продукцию в день консультации&nbsp;<span
                                    class="button button--ghost card__content-info button-open-popup" type="button"
                                    data-id="PopupMiniaturesDiscount" title="Посмотреть подробности">
                                    <i class="icon icon-info" aria-label="icon info"></i>
                                </span>
                            </p>
                        </div>
                    </div>

                    <div class="card card--benefit card--bordered card-with-miniature">
                        <i class="card__icon icon-doctor" aria-label="icon doctor"></i>
                        <div class="card__content">
                            <p class="p card__content-text">Длительность консультации 30 минут&nbsp;<span
                                    class="button button--ghost card__content-info button-open-popup" type="button"
                                    data-id="PopupMiniaturesLength" title="Посмотреть подробности">
                                    <i class="icon icon-info" aria-label="icon info"></i>
                                </span>
                            </p>
                        </div>
                    </div>

                    <div class="card card--benefit card--bordered card-with-miniature">
                        <i class="card__icon icon-products" aria-label="icon products"></i>
                        <div class="card__content">
                            <p class="p card__content-text">Персональный подбор косметики и коррекцию вашего домашнего
                                ухода&nbsp;<span class="button button--ghost card__content-info button-open-popup" type="button"
                                    data-id="PopupMiniaturesCosmetics" title="Посмотреть подробности">
                                    <i class="icon icon-info" aria-label="icon info"></i>
                                </span>
                            </p>
                        </div>
                    </div>

                    <div class="card card--benefit card--bordered card-with-miniature">
                        <i class="card__icon icon-face" aria-label="icon face"></i>
                        <div class="card__content">
                            <p class="p card__content-text">Определение типа и состояния вашей кожи&nbsp;<span
                                    class="button button--ghost card__content-info button-open-popup" type="button"
                                    data-id="PopupMiniaturesSkin" title="Посмотреть подробности">
                                    <i class="icon icon-info" aria-label="icon info"></i>
                                </span>
                            </p>
                        </div>
                    </div>

                    <div class="card card--benefit card--bordered card-with-miniature">
                        <i class="card__icon icon-plastic-recycle" aria-label="icon plastic-recycle"></i>
                        <div class="card__content">
                            <p class="p card__content-text">Скидка 15% за пустую тару&nbsp;<span
                                    class="button button--ghost card__content-info button-open-popup" type="button"
                                    data-id="PopupMiniaturesRecycle" title="Посмотреть подробности">
                                    <i class="icon icon-info" aria-label="icon info"></i>
                                </span>
                            </p>
                        </div>
                    </div>

                </div>
            </div>

            <div class="popup popup--miniatures" id="PopupMiniaturesSkin">
                <div class="popup__wrapper">
                    <button class="button button--ghost--dark popup__close" type="button" title="Close popup">
                        <i class="icon icon-close"></i>
                    </button>
                    <div class="popup__head">
                        <h3 class="h3">Определение типа и состояния вашей кожи</h3>
                    </div>
                    <div class="popup__content">
                        <p class="p">Косметолог использует особый увеличительный прибор для диагностики кожи - дерматоскоп, а результаты диагностики вы получите по электронной почте</p>
                    </div>
                    <div class="popup__bottom">
                        <button class="button button--primary--light popup-close" type="button">Понятно</button>
                    </div>
                </div>
            </div>

            <div class="popup popup--miniatures" id="PopupMiniaturesRecycle">
                <div class="popup__wrapper">
                    <button class="button button--ghost--dark popup__close" type="button" title="Close popup">
                        <i class="icon icon-close"></i>
                    </button>
                    <div class="popup__head">
                        <h3 class="h3">Скидка 15% за пустую тару</h3>
                    </div>
                    <div class="popup__content">
                        <p class="p">
                            Принесите пустые баночки из-под нашей косметики и получите скидку 15% на покупку любых продуктов!
                        </p>
                        <p>Обратите внимание на несколько условий:</p>
                        <ul class="popup__list">
                            <li>Баночки должны быть вымыты и высушены.</li>
                            <li>
                                Сдать их можно только очно в <a href="https://geltek.ru/skin-diagnostic-center/">наших ЦДК</a>
                            </li>
                            <li>Сумма скидки за тару не суммируется с другими скидками.</li>
                            <li>Акция действует на постоянной основе.</li>
                            <li>Не суммируется с другими скидками.</li>
                        </ul>
                    </div>
                    <div class="popup__bottom">
                        <button class="button button--primary--light popup-close" type="button">Понятно</button>
                    </div>
                </div>
            </div>

            <div class="popup popup--miniatures" id="PopupMiniaturesDiscount">
                <div class="popup__wrapper">
                    <button class="button button--ghost--dark popup__close" type="button" data-id="PopupMiniatures" title="Close popup">
                        <i class="icon icon-close"></i>
                    </button>
                    <div class="popup__head">
                        <h3 class="h3">Скидка 15% на всю продукцию в день консультации</h3>
                    </div>
                    <div class="popup__content">
                        <p class="p">И другие сезонные акции и предложения</p>
                    </div>
                    <div class="popup__bottom">
                        <button class="button button--primary--light popup-close" type="button">Понятно</button>
                    </div>
                </div>
            </div>

            <div class="popup popup--miniatures" id="PopupMiniaturesLength">
                <div class="popup__wrapper">
                    <button class="button button--ghost--dark popup__close" type="button" data-id="PopupMiniatures" title="Close popup">
                        <i class="icon icon-close"></i>
                    </button>
                    <div class="popup__head">
                        <h3 class="h3">Длительность консультации 30 минут</h3>
                    </div>
                    <div class="popup__content">
                        <p class="p">Этого времени достаточно для того, чтобы сделать полную диагностику кожи, подобрать уход и провести легкую уходовую процедуру с тестированием рекомендованной косметики</p>
                    </div>
                    <div class="popup__bottom">
                        <button class="button button--primary--light popup-close" type="button">Понятно</button>
                    </div>
                </div>
            </div>

            <div class="popup popup--miniatures" id="PopupMiniaturesCosmetics">
                <div class="popup__wrapper">
                    <button class="button button--ghost--dark popup__close" type="button" title="Close popup">
                        <i class="icon icon-close"></i>
                    </button>
                    <div class="popup__head">
                        <h3 class="h3">Персональный подбор косметики и коррекция вашего домашнего ухода</h3>
                    </div>
                    <div class="popup__content">
                        <p class="p">Косметолог делает опрос и уточняет ваши индивидуальные пожелания по уходу</p>
                    </div>
                    <div class="popup__bottom">
                        <button class="button button--primary--light popup-close" type="button">Понятно</button>
                    </div>
                </div>
            </div>
        `;

        descriptionEl.insertAdjacentElement("afterend", benefits);

        initMiniatures();
    }

    mainTitleEl.innerText = newMainTitle;

    lastBreadcrumbItem.innerText = newMainTitle;

    if (centerEl.previousElementSibling) {
        document.querySelector(`#center-${serviceType} .breadcrumbs`).remove();
        const firstBreadcrumbs = document.querySelector(".skin-diagnostic-center__content-city:first-child .breadcrumbs");
        firstBreadcrumbs.querySelector(".breadcrumbs__item:last-child").innerText += `; в ${newAddress}`;
        document.querySelectorAll(".section__back").forEach((back, index) => {
            if (index) {
                back.remove();
            }
        });
    }

    addressTitle.innerText = newAddressTitle;
}
